const styles = {
  selected: {
    marginLeft: "-15px",
    height: "30px",
    width: "30px",
    backgroundColor: "#003299",
    borderRadius: "50%",
  },
  unselected: {
    marginLeft: "-15px",
    height: "30px",
    width: "30px",
    backgroundColor: "#A6A6A6",
    borderRadius: "50%",
  },
  textSelected: {
    marginLeft: "20px",
    color: "#003299",
    fontSize: "16px",
  },
  textUnselected: {
    marginLeft: "20px",
    color: "#A6A6A6",
    fontSize: "16px",
  },
  PinsContainer: {
    cursor: "pointer",
    marginTop: "70px",
    position: "fixed",
    height: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  PinsAlignement: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  ContentContainer: {
    margin: "0 auto",
    maxWidth: "50%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0px 0px 0 px 20px",
    backgroundColor: "white",
  },
  TitleDivider: {
    marginTop: "20px",
    marginBottom: "20px",
    marginLeft: "20px",
    width: "100px ",
    borderTop: "3px solid #003299",
  },
  ProjectText: { marginTop: "30px", fontSize: "17px" },
  ProjectBlueText: {
    marginTop: "30px",
    fontSize: "17px",
    color: "#003299",
  },
  subTitle: {
    marginTop: "150px",
    color: "#003299",
    fontSize: "25px",
    fontWeight: "bold",
  },
  ProjectLogo: {
    maxWidth: "100%",
    display: "block",
    height: "auto",
    width: "auto",
  },
  ProjectDefinitionContainer: {
    margin: "40px auto 0",
    display: "flex",
    flexDirection: "row",
    height: "80%",
    maxHeight: "80%",
    overflowY: "scroll",
  },
  ProjectDefinitionLeftSideContainer: {
    marginRight: "auto",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  ProjetTitleAndToogleNavigatorContainer: {
    display: "flex",
    flexDirection: "column",
  },
  SideMenuIcon: { display: "flex", color: "#003299", size: "20px" },
  ProjectTitle: {
    marginLeft: "10px",
    marginTop: "-30px",
    minWidth: "100px",
    color: "#003299",
    fontSize: "20px",
    position: "fixed",
    fontWeight: "bold",
  },
  ExtendButtonContainer: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    marginTop: "25px",
  },
};
export default styles;
